import { css } from "styled-components";
import {
  fontFamily,
  breakpoints,
  colors,
  interaction,
  sectionRhythm,
} from "../../theme";

/** Shared blog body typography - aligned with caseStudyBodyStyles */
export const blogProseParagraph = css`
  letter-spacing: -0.003em;
  line-height: 28px;
  font-size: 16px;
  margin: 0;
  color: ${colors.body};
  font-family: ${fontFamily.regular};

  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 20px;
    line-height: 32px;
  }
`;

export const blogProseHeadingType = css`
  letter-spacing: 0;
  line-height: 1.2;
  font-size: 24px;
  font-family: ${fontFamily.extraBold};

  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 28px;
  }
`;

export const blogProseHeading = css`
  ${blogProseHeadingType}
  margin-top: ${sectionRhythm.paddingY.mobile}px;
  margin-bottom: 8px;

  @media only screen and (min-width: ${sectionRhythm.breakpoint}) {
    margin-top: ${sectionRhythm.paddingY.desktop}px;
  }
`;

export const blogProseSectionTitle = css`
  ${blogProseHeadingType}
  margin-top: 0;
  margin-bottom: 8px;
`;

export const blogProseList = css`
  ol,
  ul {
    padding: 0;
    list-style: none;
    list-style-image: none;
  }

  li {
    margin-top: 0.86em;
    letter-spacing: -0.003em;
    line-height: 28px;
    padding-left: 0;
    margin-left: 20px;
    list-style-type: decimal;
    margin-bottom: 0;
    font-size: 16px;
    color: ${colors.body};
    font-family: ${fontFamily.regular};

    @media only screen and (min-width: ${breakpoints.tablet}) {
      font-size: 20px;
      line-height: 32px;
    }
  }
`;

export const blogProseImage = css`
  p img:not([data-case-study-img]) {
    width: 100%;
    height: auto;
    margin-top: 1em;
  }
`;

export const blogProseLink = css`
  a {
    color: inherit;
    text-decoration: underline;
    transition: ${interaction.transition};
    cursor: pointer;

    &:hover,
    &:focus-visible {
      color: ${colors.linkHover.light};
      text-decoration: underline;
    }
  }
`;

export const blogProse = css`
  p {
    ${blogProseParagraph}
  }

  p + p {
    margin-top: 1em;
  }

  h3 {
    ${blogProseHeading}
  }

  h3:first-child {
    margin-top: 0;
  }

  ${blogProseList}
  ${blogProseImage}
  ${blogProseLink}
`;

export const blogProseBody = css`
  && p {
    ${blogProseParagraph}
  }

  && p + p {
    margin-top: 1em;
  }

  && {
    ${blogProseList}
    ${blogProseLink}
  }
`;
